<template>
  <div class="content-panel">
    <a-card :bordered="false">
      <a-input-search
        v-model="searchValue"
        style="margin-bottom: 8px"
        placeholder="支持对菜单名称的模糊查询"
        @search="queryMenuData"/>
      <a-button type="primary" v-action:add v-if="isAdmin" @click="append('top')" block>新建一级菜单</a-button>
      <!-- showIcon -->
      <a-tree
        :treeData="treeData"
        :draggable="$auth('menu.drag')"
        @expand="onExpand"
        :expandedKeys="expandedKeys"
        @dragstart="onStart"
        @drop="showConfirm"
        @select="select"
        :selectedKeys="selectedKeys"
        :autoExpandParent="autoExpandParent"
      >
        <a-icon slot="file" type="file" />
        <a-icon slot="alert" type="alert" />
        <template slot="custom" slot-scope="item">
          <span>{{ item.title }}</span>
          <div class="icon-panel">
            <a-tooltip>
              <template slot="title">
                新建
              </template>
              <a-icon type="plus" v-if="isAdmin" v-action:add @click="() => append(item)" />
            </a-tooltip>
            <a-tooltip>
              <template slot="title">
                新建按钮
              </template>
              <a-icon type="setting" v-if="isAdmin" v-action:addBtn @click="() => appendBtn(item)" />
            </a-tooltip>
            <a-popconfirm placement="topRight" :title="'您确定要删除' + item.name + '吗?'" @confirm="e => remove(item)">
              <a-tooltip>
                <template slot="title">
                  删除
                </template>
                <a-icon type="delete" v-if="isAdmin" v-action:delete style="color: red"/>
              </a-tooltip>
            </a-popconfirm>
          </div>
        </template>
      </a-tree>
    </a-card>
    <edit-btn-modal ref="editBtnModal" @refreshTable="refreshTable"></edit-btn-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { getMenuInfo, deleteMenuInfo, dragMenuInfo } from '@/api/menu.js'
import editBtnModal from './editBtnModal'
export default {
  components: {
    editBtnModal
  },
  data () {
    return {
      treeData: [],
      searchValue: '',
      dragSort: Number,
      dragId: Number,
      autoExpandParent: true,
      selectedKeys: [],
      expandedKeys: [],
      newChild: {},
      isAppend: false,
      firstLogin: true
    }
  },
  computed: {
    ...mapGetters(['isAdmin'])
  },
  created () {
    this.queryMenuData()
  },
  methods: {
    ...mapActions(['handleMenuList', 'handleBtnInfo']),
    onExpand (expandedKeys) {
      console.log('expandedKeys', expandedKeys)
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    async queryMenuData (info) {
      const query = {
        paging: false,
        name: this.searchValue.trim()
      }
      const res = await getMenuInfo(query)
      console.log('res', res)
      if (res.status === 0) {
        this.treeData = res.data
        if (this.firstLogin) {
          const selectedItem = this.treeData[0]
          this.selectedKeys.push(selectedItem.key)
          if (selectedItem.pid === 0) {
            selectedItem.pName = '一级菜单'
          }
          // 默认第一条数据被选中
          this.handleMenuList(selectedItem)
          this.firstLogin = false
        }
      } else {
        this.$message.error(res.info.message)
      }
    },
    // 递归查找
    searchOption (option, arr, type = 'delect') {
      // console.log(option, arr, type)
      for (let s = 0; s < arr.length; s++) {
        console.log(arr[s].key, option.key)
        if (arr[s].key === option.key) {
          if (type === 'delect') {
            arr.splice(s, 1)
          }
          break
        } else if (arr[s].children && arr[s].children.length > 0) {
          // 递归条件
          this.searchOption(option, arr[s].children)
        } else {
          continue
        }
      }
    },
    // 添加菜单
    append (data) {
      const newChild = {
        name: '新建菜单',
        title: '新建菜单',
        key: null,
        id: null,
        isHiddenHeaderContent: 1,
        isHidden: 0,
        isKeepAlive: 0,
        pid: data.id || 0,
        scopedSlots: { title: 'custom' },
        children: []
      }
      if (data === 'top') {
        newChild.pName = '一级菜单'
      } else {
        this.isAppend = true
        newChild.pName = data.name
      }
      this.handleMenuList(newChild)
      this.$emit('formTitle', '新建菜单')
    },
    // 添加按钮
    appendBtn (data) {
      this.$refs.editBtnModal.setTitle('新增按钮')
      this.$refs.editBtnModal.setType(this.$sysInfo.MODAL_ADD) // 先设置类型，再打开
      this.$refs.editBtnModal.setName(data)
      this.$refs.editBtnModal.open(true)
    },
    // 添加按钮 -提交后回调
    refreshTable () {
      this.$emit('refreshTable')
    },
    // 选择一个菜单
    select (selectedKeys, info) {
      if (selectedKeys.length === 0) {
        selectedKeys.push(info.node.eventKey)
      }
      this.selectedKeys = selectedKeys
      if (info.selectedNodes.length) {
        var selectedItem = info.selectedNodes[0].data.props
        this.expandedKeys.push(selectedKeys[0])
        this.expandedKeys = Array.from(new Set(this.expandedKeys))
        if (selectedItem.pid === 0) {
          selectedItem.pName = '一级菜单'
        }
        selectedItem.key = info.node.dataRef.key
        if (!this.isAppend) {
          this.handleMenuList(selectedItem)
          this.$emit('formNavTitle', '编辑菜单')
        }
      }
      this.isAppend = false
    },
    // 删除菜单
    async remove (data) {
      // 先请求后端接口，删除成功后执行
      // 如果存在ID那么需要调接口删除
      if (data.key) {
        const res = await deleteMenuInfo(data.id)
        if (res.status === 0) {
          this.$message.success('删除成功')
        } else {
          this.$message.error(res.info.message)
        }
      }
      this.searchOption(data, this.treeData)
      this.handleMenuList({})
    },
    // 拖拽的确认
    showConfirm (info) {
      const vm = this
      var realPos, query
      console.log('拖拽的INFO', info)
      // const dropKey = info.node.eventKey
      // const dragKey = info.dragNode.eventKey
      const dropPos = info.node.pos.split('-')
      const dragPos = info.dragNode.pos.split('-')
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      // const parentNode = info.dragNode.pos.split('-')[1]
      // console.log('dropPos', dropPos)
      // console.log('dragPos', info.dragNode.pos.split('-'))
      // console.log('parentNode', info.dragNode.pos.split('-')[1])
      // 判断是否在同一个父节点下移动
      if (dragPos.length === dropPos.length && dragPos[dragPos.length - 2] === dropPos[dropPos.length - 2]) {
        if (dropPosition === -1) {
          realPos = Number(dropPos[dropPos.length - 1]) + 1
        } else {
          realPos = Number(dropPos[dropPos.length - 1]) + 2
        }
        if (Number(dragPos[dragPos.length - 1]) < Number(dropPos[dropPos.length - 1])) {
          realPos = realPos - 1
        }
      } else {
        if (dropPosition === -1) {
          realPos = info.dropPosition + 2
        } else {
          realPos = info.dropPosition + 1
        }
      }
      query = {
        id: info.dragNode.dataRef.id,
        pid: dropPosition === 0 ? info.node.dataRef.id : info.node.dataRef.pid,
        position: realPos
      }
      // console.log('query', query)
      // console.log('dropPosition', dropPosition)
      let showTitle = ''
      if (dropPosition === 0) {
        console.log('长度', info.node.dataRef.children.length)
        const childPos = info.node.dataRef.children.length + 1
        query.position = childPos
        showTitle = `您确定修改【${info.dragNode.dataRef.name}】的父节点为【${info.node.dataRef.name}】并调整顺序为第【${childPos}】位吗?`
      } else {
        showTitle = `您确定修改【${info.dragNode.dataRef.name}】的父节点为【${info.node.dataRef.pName ||
          '一级菜单'}】并调整顺序为第【${query.position}】位吗?`
      }
      this.$confirm({
        title: showTitle,
        onOk () {
          return new Promise((resolve, reject) => {
            setTimeout(resolve, 1000)
            vm.onDrop(info, query)
          }).catch(() => console.log('errors!'))
        },
        onCancel () {}
      })
    },
    // 开始拖拽
    onStart (info) {
      this.dragSort = info.node.dataRef.sort
      this.dragId = info.node.dataRef.id
    },
    // 菜单拖拽
    async onDrop (info, query) {
      const res = await dragMenuInfo(query)
      console.log('拖拽的返回', res)
      if (res.status === 0) {
        this.$message.success('操作成功!')
        // 拖拽完后重新获取树信息(因为sort值已经改变)
        this.queryMenuData()
      } else {
        this.$message.error(res.info.message)
      }
    }
  }
}
</script>
<style lang="less">
.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  // .ant-tree-title {
  //   width: 100%;

  //   & > span {
  //     // max-width: 90px;
  //     display: inline-block;
  //     white-space: pre-line;
  //   }
  // }
  // .title {
  //   float: left;
  // }
  .ant-card-body {
    padding: 0;
    .ant-btn {
      margin-bottom: 12px;
    }

    // :global {
    //   .ant-tree {
    //     line-height: 3;

    //     .ant-tree-node-content-wrapper,
    //     .ant-tree-switcher {
    //       margin-top: 7px;
    //     }
    //     .ant-tree-node-content-wrapper:hover {
    //       background: transparent;
    //     }
    //     .ant-tree-treenode-selected {
    //       background: #e6f7ff;
    //       .ant-tree-node-selected {
    //         background: transparent;
    //       }
    //     }

    //     .ant-tree-child-tree {
    //       background: #fff;
    //     }
    //     li {
    //       position: relative;
    //       line-height: 3;
    //       padding-bottom: 0;
    //     }
    //   }
    //   .ant-btn {
    //     margin-bottom: 8px;
    //   }
    // }

    // .icon-panel {
    //   float: right;
    //   position: absolute;
    //   right: 10px;
    //   top: 13px;

    //   .anticon-plus,
    //   .anticon-setting,
    //   .anticon-delete {
    //     margin-left: 5px;
    //     color: #1890ff;
    //   }
    // }
  }
}
</style>
